<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex mb-8 items-center rounded-md p-1">
                            <p class="font-semibold text-xl text-neutral-800">Salary slip for {{ formatMonthYear(this.filterMonth) }}</p>
                            <div class="ml-auto" v-if="userType === 'admin'">
                                <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                                <select class="border rounded-lg px-2 py-2 text-sm" v-model="slectedLocation" @change="fetchSalaryRequests">
                                    <option value="">Location</option>
                                    <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                                </select>
                            </div>

                            <div class="w-96 mr-3 ml-2.5">
                                <input type="search" v-model="searchQuery"
                                    class="w-full bg-white outline-none block font-normal border rounded-lg px-2 py-2.5 text-sm"
                                    placeholder="Search...">
                            </div>

                            <p class="text-sm leading-none font-medium text-black moth-bxd flex items-center border rounded-lg pl-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                                        <path fill="#cfd8dc" d="M5 38V14h38v24c0 2.2-1.8 4-4 4H9c-2.2 0-4-1.8-4-4"/>
                                        <path fill="#f44336" d="M43 10v6H5v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4"/>
                                        <g fill="#b71c1c"><circle cx="33" cy="10" r="3"/><circle cx="15" cy="10" r="3"/></g>
                                        <path fill="#b0bec5" d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2M15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"/>
                                        <path fill="#90a4ae" d="M13 20h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4z"/>
                                    </svg>
                                    <month-picker-input v-model="filterMonth" :no-default="true" @change="logEffectiveFrom"
                                    :placeholder="'Select Month'" />
                                </p>
                            <!-- <div>
                                <button class="btn-primary">
                                    Download
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2"><path fill="currentColor" d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z"/></svg>
                                </button>
                            </div> -->
                        </div>
                        <!-- <div class="mb-2">
                            <p class="font-medium text-sm text-black ">Number of Employee: <span class="text-neutral-700 font-normal">0</span> </p>
                        </div> -->
                        <div class="overflow-y-auto">
                            <div class="min-w-[1450px]">
                                <div class="grid grid-cols-13 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                                    <div
                                        class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">
                                        Emp
                                        Id</div>
                                    <div
                                        class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">
                                        Emp
                                        Name</div>
                                    <div
                                        class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">
                                        DOJ
                                    </div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Day
                                        Present
                                    </div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Paid Leave
                                        Taken</div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Unpaid
                                        Leave
                                        Taken</div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Max Pay
                                    </div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Generate
                                        Salary Slip</div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Status
                                    </div>
                                    <div class="text-xs leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center">
                                        Download</div>
                                </div>
<!-- 
                                <div v-if="loading" class="flex justify-start items-center py-6">
                                    <div class="ml-[27%]">
                                        <svg class="animate-spin h-6 w-6 text-blue-500"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4" />
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                        </svg>
                                        <span class="ml-2 text-sm text-neutral-600">Loading...</span>
                                    </div>
                                </div> -->

                                <div v-if="loading" class="min-w-[1450px]">
                                    <!-- Skeleton Loader -->
                                    <div class="grid grid-cols-13 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 4" :key="index">
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div v-if="paginatedData.length === 0" class="text-center py-6 text-neutral-500 text-sm">
                                     No data found.
                                     </div>
                                    <div v-for="(employee, index) in paginatedData" :key="index">
                                        <div
                                            class="grid grid-cols-13 bg-white divide-x divide-y divide-[#eaeaea]">
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal col-span-2 border-t border-[#eaeaea]">
                                                {{ employee.empid }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal col-span-2">
                                                {{ employee.fname }} {{ employee.lname }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center col-span-2">
                                                {{ employee.doj }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                {{ employee.report.present_days }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                {{ employee.report.paidLeaveDays }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                {{ employee.report.unpaidLeaveDays }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                {{ employee.employee_salary.netpay }}
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                <button @click="isOpen(employee)"
                                                    class="inline-flex items-center justify-center bg-blue-400 rounded-md px-2 py-1 text-white text-[10px] font-normal">Generate</button>
                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">
                                                <span class="flex items-center">
                                                    <span class="block w-1.5 h-1.5 rounded-full mr-1"
                                                        :class="employee.status === 'Pending' ? 'bg-red-500' : 'bg-green-500'"></span>
                                                    {{ employee.status }}
                                                </span>

                                            </div>
                                            <div
                                                class="text-sm leading-none px-2 pb-2 flex items-center font-normal justify-center" v-if="employee.status === 'Approved'">
                                                <button @click="exportToPDF(employee)"
                                                    class="inline-flex items-center justify-center text-neutral-600 rounded-md p-1 text-xs font-normal">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24">
                                                        <path fill="currentColor"
                                                            d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z" />
                                                    </svg>
                                                </button>

                                                <button class="inline-flex items-center justify-center bg-blue-400 rounded-md px-2 py-1 text-white text-[10px] font-normal"
                                                @click="sendPayslipByEmail(employee)">Send Email</button>
                                            </div>
                                        </div>

                                    </div>
                                    <PaginationComponent :totalItems="total" :itemsPerPage="itemsPerPage"
                                    v-model:currentPage="currentPage" />
                                </div>
                            </div>
                        </div>
                   
                    </div>
                </div>
            </div>
            <!-- <RightSideBar /> -->
        </section>
        <!-- Popup Modal -->
        <div v-if="isPopupOpen"
            class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 py-4 overflow-y-auto px-2">
            <div class="max-w-5xl w-full bg-white mx-auto rounded-lg px-3 pt-3">
                <div class="bg-blue-400 py-3 relative rounded-t-lg">
                    <h3 class="text-center text-xl font-semibold text-white capitalize">Salary Slip And Approval</h3>
                    <button @click="closePopup"
                        class="absolute top-3 right-3 rounded-full bg-white w-7 h-7 flex items-center justify-center text-blue-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16">
                            <path fill="currentColor"
                                d="M7.293 8L3.146 3.854a.5.5 0 1 1 .708-.708L8 7.293l4.146-4.147a.5.5 0 0 1 .708.708L8.707 8l4.147 4.146a.5.5 0 0 1-.708.708L8 8.707l-4.146 4.147a.5.5 0 0 1-.708-.708z" />
                        </svg>
                    </button>
                </div>
                <div class="grid grid-cols-2 py-3">
                    <div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Employee Name</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.fname }} {{
                                selectedEmployee?.lname }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Employee ID</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.empid }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">DOJ (Date Of Joining)</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.doj }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">PAN</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.pan }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Department</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.dept }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">CTC</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                this.selectedEmployee.employee_salary.ctc }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Gross Salary</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.gross_pay
                                }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">UAN (Universal Account Number)
                            </p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.uan }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">ESIC Number</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ selectedEmployee?.esic }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Basic Salary Payable</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.basic }}
                            </p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">HRA (House Rent Allowance)</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.hra }}</p>
                        </div>
                        <!-- <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Conveyance allowance</p>
                            <p class="text-sm truncate font-normal text-neutral-800">5000</p>
                        </div> -->
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Other Allowence Payslip</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                this.selectedEmployee.other_allowance }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4"></p>
                            <p class="text-sm truncate font-normal text-neutral-800"></p>
                        </div>
                    </div>
                    <div class="border-l border-neutral-300 pl-10">
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Total Days</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.totalDays }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Total Working Days</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.totalWorkingDays }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">LOP (Loss Of Pay)</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.lossPay }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Paid Days</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.paidDays }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Days Present</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.present_days }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Paid Leave</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.paidLeaveDays }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Unpaid Leave</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                selectedEmployee?.report?.unpaidLeaveDays }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">PF Payabale</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.pfpayable
                                }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">ESI Payable</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.esi }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Professional Tax</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.ptax }}
                            </p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">EPS Payabale</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.eps }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">ER Payabale</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.er }}</p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">ESIC2</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.esic2 }}
                            </p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Total Deductions</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{
                                this.selectedEmployee.totaldeduction }}</p>
                        </div>

                        <div class="grid grid-cols-2 py-1.5 border-t border-neutral-200 pt-3 mt-3">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Net Pay</p>
                            <p class="text-sm truncate font-normal text-neutral-800">{{ this.selectedEmployee.netpay }}
                            </p>
                        </div>
                        <div class="grid grid-cols-2 py-1.5">
                            <p class="text-sm truncate font-medium text-neutral-800 pr-4">Total Amount In Words Rupees
                            </p>
                            <p class="text-sm truncate font-normal text-neutral-800 bg-neutral-200 p-1 pl-2 rounded-lg">
                                {{ this.selectedEmployee.salaryinwords }}</p>
                        </div>
                    </div>
                </div>
                <div class="w-[30%] ml-auto mb-5">
                    <button @click="submitSalarySlip"
                        class="flex w-fit items-center justify-center bg-blue-400 rounded-md px-3 py-1 text-white text-bale font-normal mx-auto">Approve</button>
                </div>
            </div>
        </div>
    </AdminLayout>
</template>

<script>
import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import PaginationComponent from "../../components/PaginationComponent.vue";
import axios from 'axios';
import { BASE_URL} from "../../config";
import debounce from 'lodash/debounce';
import { createToast } from 'mosha-vue-toastify';
import { MonthPickerInput } from 'vue-month-picker'
import html2pdf from "html2pdf.js";
import dayjs from 'dayjs';
import { createLocal } from 'the-storages';

const mirror = createLocal();
const storage = mirror._prx;
export default {
    name: 'LeaveListing',
    components: {
        AdminLayout,
        // RightSideBar,
        PaginationComponent,
        MonthPickerInput,
    },
    data() {
        return {
            filterMonth: new Date(),
            isPopupOpen: false,
            data: [],
            itemsPerPage: 10,
            currentPage: 1,
            total: 0,
            searchQuery: null,
            salaryConfig: null,
            loading: true,
            selectedEmployee: null,
            company: null,
            countries: [],
            states: [],
            storage:storage,  
            branchList: [],  
            slectedLocation: '',   
            userType: '', 
            previousLocation: '', // Add this to track location changes
        };
    },
    computed: {
        paginatedData() {
            return this.data;
        }
    },
    watch: {
        searchQuery() {
            this.onSearch();
        },
        currentPage(newPage) {
            this.$router.push({ query: { ...this.$route.query, page: newPage } }); // ← add this
            this.fetchSalaryRequests();
        }
    },
    methods: {
        async sendPayslipByEmail(employee) {
        try {
            await this.exportToPDF(employee, true);
        } catch (error) {
            console.error('Error:', error);
        }
        },
        async getBranchList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-emp-branch-list',formData)
                .then((response)=>{
                    this.branchList =  response.data.branchDetails;
                    console.log("Role LIST:: ",response.data);
                })
            },
        async fetchData() {
            try {
                const stored = localStorage.getItem('companyDetails')
                if (stored) {
                this.company = stored
                }

                const [countryRes, stateRes] = await Promise.all([
                axios.get(BASE_URL +'/country-list'),
                axios.get(BASE_URL +'/cState-list', {
                params: { country: this.company.country }  // ✅ pass country code
                })
                ])

                this.countries = countryRes.data.countryList
                this.states = stateRes.data.statelist[0].states
                console.log(this.countries);
                console.log(this.states);
            } catch (err) {
                console.error('Failed to fetch data:', err)
            }
        },
    getCountryName(code) {
      const country = this.countries.find(c => c.code === code)
      return country ? country.name : code
    },
    getStateName(stateCode) {
      // If `states` are flat:
      const state = this.states.find(
        s => s.state_code === stateCode
      )
      return state ? state.name : stateCode

      // If `states` are nested under each country:
      /*
      const countryEntry = this.states.find(c => c.iso2 === countryCode)
      const state = countryEntry?.states.find(s => s.state_code === stateCode)
      return state ? state.name : stateCode
      */
    },
        updateEmployeeStatus(empid, newStatus) {
            const employee = this.paginatedData.find(emp => emp.uid === empid);
            if (employee) {
            employee.status = newStatus;
            }
        },
        openPopup() {
            this.isPopupOpen = true;
        },
        closePopup() {
            this.isPopupOpen = false;
        },
        tostMessage(type, message) {
            createToast({ description: message }, {
                type,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: true
            });
        },
        formatMonthYear(dateStr) {
         return dayjs(dateStr).format('MMMM YYYY');
        },

        async submitSalarySlip() {
            try {
                const emp = this.selectedEmployee;

                const payload = {
                    month: this.filterMonth,
                    uid: emp.uid,
                    company_id: emp.company_id,
                    empid: emp.empid,
                    name: `${emp.fname} ${emp.lname}`,
                    doj: emp.doj,
                    pan: emp.pan,
                    dept: emp.dept,
                    uan: emp.uan,
                    esic: emp.esic,
                    ctc: emp.employee_salary?.ctc,
                    gross_salary: emp.gross_pay,
                    basic: emp.basic,
                    hra: emp.hra,
                    other_allowance: emp.other_allowance,
                    pfpayable: emp.pfpayable,
                    esi: emp.esi,
                    ptax: emp.ptax,
                    eps: emp.eps,
                    er: emp.er,
                    esic2: emp.esic2,
                    totaldeduction: emp.totaldeduction,
                    netpay: emp.netpay,
                    salaryinwords: emp.salaryinwords,

                    // Report Data
                    totalDays: emp.report?.totalDays,
                    totalWorkingDays: emp.report?.totalWorkingDays,
                    lossPay: emp.report?.lossPay,
                    paidDays: emp.report?.paidDays,
                    present_days: emp.report?.present_days,
                    paidLeave: emp.report?.paidLeaveDays,
                    unpaidLeave: emp.report?.unpaidLeaveDays,
                    companydeduction: emp.companydeduction,
                    jobtitle: emp.jobtitle
                };


                const res = await axios.post(`${BASE_URL}/submit-salary-slip`, payload);
                if (res) {
                    createToast('Salary slip approved successfully', { type: 'success' });
                    this.updateEmployeeStatus(emp.uid, 'Approved');
                    this.isPopupOpen = false;
                }

            } catch (error) {
                const message = error.response?.data?.message || 'Error submitting salary slip';
                createToast(message, { type: 'danger' });
                console.error(error);
            }

        },




        async exportToPDF(employee, sendEmail= false) {
            console.log("exportToPDF");
            const config = this.salaryConfig;
            this.selectedEmployee = employee;
            this.selectedEmployee.email = employee.email;
            // Helper values
            const report = this.selectedEmployee?.report || {};
            const salary = this.selectedEmployee?.employee_salary || {};

            const totalDaysInMonth = report.totalDaysInMonth || 30;
            const paidDays = (report.present_days || 0) + (report.paidLeaveDays || 0);
            const payableDays = (report.totalDays || 30) - ((report.totalWorkingDays || 0) - paidDays);
            const paidRatio = payableDays / totalDaysInMonth;

            // Basic components
            const rawBasic = salary.basic * paidRatio;
            const rawHRA = salary.hra * paidRatio;
            const rawOther = salary.other_allowance * paidRatio;

            this.selectedEmployee.basic = Math.round(rawBasic);
            this.selectedEmployee.hra = Math.round(rawHRA);
            this.selectedEmployee.other_allowance = Math.round(rawOther);

            // Gross Pay
            const grossPay = rawBasic + rawHRA + rawOther;
            this.selectedEmployee.gross_pay = Math.round(grossPay);

            // PTax
            this.selectedEmployee.ptax = 0;
            for (let slab of config.ptax) {
                if (grossPay >= +slab.from && grossPay <= +slab.to) {
                    this.selectedEmployee.ptax = +slab.amount;
                    break;
                }
            }

            // PF Payable
            const basicPlusAllowance = this.selectedEmployee.basic + this.selectedEmployee.other_allowance;
            if (basicPlusAllowance <= 15000) {
                this.selectedEmployee.pfpayable = Math.round(basicPlusAllowance * 0.12);
            } else if (salary.epf_amount === 0) {
                this.selectedEmployee.pfpayable = 0;
            } else {
                this.selectedEmployee.pfpayable = 1800;
            }

            // EPS and ER
            this.selectedEmployee.eps = Math.round((this.selectedEmployee.pfpayable * 8.33) / 12);
            this.selectedEmployee.er = this.selectedEmployee.pfpayable - this.selectedEmployee.eps;



            // ESI Calculation
            this.selectedEmployee.esi = config.esi.enabled === 'true' && salary.gross_pay <= 21000
                ? Math.round((grossPay * 0.0075))
                : 0;

            // Employer ESI (ESIC2)
            this.selectedEmployee.esic2 = config.esi.enabled === 'true' && salary.gross_pay <= 21000
                ? Math.round((grossPay * 0.0325))
                : 0;

            // Total Deduction
            this.selectedEmployee.totaldeduction =
                this.selectedEmployee.pfpayable +
                this.selectedEmployee.esi +
                this.selectedEmployee.ptax;

            // Net Pay
            this.selectedEmployee.netpay =
                this.selectedEmployee.gross_pay -
                this.selectedEmployee.totaldeduction;
            var num = this.selectedEmployee.netpay;
            this.selectedEmployee.salaryinwords = this.number2text(num);
            // Company Deduction
            this.selectedEmployee.companydeduction =
                this.selectedEmployee.eps +
                this.selectedEmployee.er +
                this.selectedEmployee.esic2;

            // PF for CTC calculation
            let pf_ctc = 0;
            if (salary.epf_amount !== 0) {
                if (basicPlusAllowance > 15000) {
                    pf_ctc = 1800;
                } else {
                    pf_ctc = basicPlusAllowance * 0.12;
                }
            }

            console.log(pf_ctc, "------pf_ctc", paidRatio, grossPay, this.selectedEmployee.esic2)

            // CTC Calculation
            const ctcValue = (grossPay / paidRatio) + pf_ctc + this.selectedEmployee.esic2;
            this.selectedEmployee.ctc = Math.round(ctcValue);

            //console.log("CTC:", this.selectedEmployee.ctc);
            this.htmltopdf(this.selectedEmployee, sendEmail);

        },


        async getBase64Image(url) {
            console.log("url", url);

            try {
                const response = await axios.get(url, { responseType: 'arraybuffer' });
                // Convert binary data to Base64 string
                const contentType = response.headers['content-type'] || 'image/png';
                const base64 = btoa(String.fromCharCode(...new Uint8Array(response.data)));
                //return `data:image/svg+xml;base64,${base64}`; // Specify SVG MIME type here
                return `data:${contentType};base64,${base64}`;
            } catch (error) {
                console.error("Error fetching image:", error);
                return ''; // Return an empty string or handle the error as needed
            }
        },



        async htmltopdf(res, sendEmail = false) {
            //console.log("logo", logo);
            //console.log("test...htmltopdf");
            const emp = res;

            console.log(emp, "========================");
            const company = localStorage.getItem('companyDetails');
            
            // var url =
            //     "https://employee.works-reddensoft.com/admin/public/assets/reddensoft_logo.svg";
            //var url = BASE_URL_POP + company.logo;
            //alert(url);
            const logoPath = company.logo.split('/').pop(); // gets just the filename
            const ress = await axios.get(`${BASE_URL}/logo-base64/`+logoPath);
            const base64Logo = ress.data.base64;

            //const base64Logo = await this.getBase64Image(url);
            var htmldemo =
                `
        <style></style>
        <div style="width:100%;margin-left:-20px;transform: scale(0.84)" id="pdfFormat">
           
           <table width="100%" style="border-spacing:0px;margin:auto;font-family: sans-serif; padding: 0px; width:100%;" bgcolor="#ffffff"
           cellspacing="0" cellpadding="0" border="0" v-if="hidden">
                <tbody>
                    <tr>
                        <td>
                            <table style="border-spacing:0px;font-family: "Roboto", sans-serif; border: 1px solid #b9b9b9;"
                                bgcolor="#ffffff" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr>
                                        <td style="padding: 20px 20px;">
                                            <table width="100%" align="center" style="border-spacing:0px;" cellspacing="0"
                                                cellpadding="0" border="0">
                                                <tbody>
                                                    <tr>
                                                        <td style="padding-right: 10px;">
                                                            <img width="100" height="28.11"
                                                                style=" vertical-align: text-top;text-align: center;"
                                                                src="${base64Logo}" alt="">
                                                        </td>
                                                        <td align="right">
                                                            <table style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 15px;font-weight: 700;color: #000;padding:0 0 4px;">
                                                                            ${ company.orgname }
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 10px;font-weight: 400;color: #000;">
                                                                             ${company.address} ${this.getStateName(company.state)} ${this.getCountryName(company.country)} ${company?.pin || ''}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 10px;font-weight: 400;color: #000;padding:0 0 4px;">
                                                                            <strong> PAN:</strong> ${company.pan || 'N/A'}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="border-top: 1px solid #b9b9b9;padding: 10px 0;">
                                            <table align="center" style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                border="0">
                                                <tbody>
                                                    <tr>
                                                        <td align="center"
                                                            style="font-size: 16px;line-height: 31px;color: #5097a9;font-weight: 600;">
                                                            Pay Slip For The Month Of ${this.formatMonthYear(this.filterMonth)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td bgcolor="#E1F1F2"
                                            style="border-top: 1px solid #b9b9b9;padding: 20px 20px 0 20px;vertical-align: top;">
                                            <table style="border-spacing:0px; padding:0;" cellspacing="0" cellpadding="0" border="0">
                                                <tbody>
                                                    <tr>
                                                        <td style="vertical-align: top; padding:0;">
                                                            <table style="border-spacing:0px; padding: 0;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 15px;">
                                                                            Emp Code</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 15px 0;">
                                                                            ${emp.empid}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 15px;">
                                                                            Name</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 15px 0;">
                                                                            ${emp.fname}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px; padding-bottom: 15px;">
                                                                            DOJ</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 15px 0;">
                                                                            ${emp.doj}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 20px;">
                                                                            CTC (In Rupees)</td>
                                                                        <td align="left"
                                                                        style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 15px 0;">
                                                                            ${emp.salaryinwords}
                                                                            
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="padding: 0 0 0 110px;vertical-align: top;">
                                                            <table style="border-spacing:0px; padding: 0;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 15px;vertical-align: top;">
                                                                            Designations</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                            ${emp.jobtitle}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 15px;vertical-align: top;">
                                                                            Department</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                            ${emp.dept}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;padding-bottom: 15px;vertical-align: top;">
                                                                            PAN</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                             ${emp.pan}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 600;color: #216997;padding-right:20px;vertical-align: top;padding-bottom: 20px;">
                                                                            UAN</td>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 0 10px 0 0;">
                                                                            ${emp?.uan || 'N/A'}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="border-top: 1px solid #b9b9b9; padding: 20px 0; vertical-align: text-top;">
                                            <table width="100%" style="border-spacing:0px;width: 100%;background-color:#f0f0f0;" cellspacing="0" cellpadding="0" border="0">
                                                <tbody>
                                                    <tr>
                                                        <td style="vertical-align: top;">
                                                            <table style="border-spacing:0px;width: 100%;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th bgcolor="#8079A0" align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                            Earning Head
                                                                        </th>
                                                                        <th bgcolor="#8079A0" align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                            Rate
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 0;vertical-align: middle;">
                                                                            Basic</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 10px;vertical-align: top;">
                                                                            ${emp.employee_salary?.basic}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            HRA</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                            ${emp.employee_salary?.hra}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            Other Allow</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                            ${emp.employee_salary?.other_allowance}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="vertical-align: top;border-left: 1px solid #b9b9b9;">
                                                            <table width="100%" style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th colspan="2" bgcolor="#8079A0" align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                            Payable
                                                                        </th>
            
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding: 10px;padding-top: 10px;vertical-align: top;">
                                                                            ${emp.basic}</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 10px;vertical-align: top;">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            ${emp.hra}</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            ${emp.other_allowance}</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;vertical-align: top;">
                                                                        </td>
                                                                    </tr>
                                                                    
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="vertical-align: top;border-left: 1px solid #b9b9b9;">
                                                            <table width="100%" style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <thead>
                                                                    <tr>
                                                                        <th bgcolor="#8079A0" align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                            Deduction
                                                                        </th>
                                                                        <th bgcolor="#8079A0" align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                            Rs
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding: 10px;padding-top: 14px;padding-top: 14px;">
                                                                            PF</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 10px;vertical-align: top;">
                                                                            ${emp.pfpayable}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            P.Tax</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;">
                                                                            ${emp.ptax}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                            ESI</td>
                                                                        <td align="right"
                                                                        style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;">
                                                                        ${emp.esi}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;">
                                                                        </td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 0 10px 10px 0;">
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>

                                                        <td style="vertical-align: top;border-left: 1px solid #b9b9b9;">
                                                        <table width="100%" style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                            border="0">
                                                            <thead>
                                                                <tr>
                                                                    <th bgcolor="#8079A0" align="left"
                                                                        style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                        C.Deduction
                                                                    </th>
                                                                    <th bgcolor="#8079A0" align="right"
                                                                        style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                        Rs
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td align="left"
                                                                        style="font-size: 13px;font-weight: 400;color: #000;padding: 10px;padding-top: 14px;padding-top: 14px;">
                                                                        EPS </td>
                                                                    <td align="right"
                                                                        style="font-size: 13px;font-weight: 500;color: #303030;padding: 10px;vertical-align: top;">
                                                                        ${emp.eps}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td align="left"
                                                                        style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                        ER</td>
                                                                    <td align="right"
                                                                        style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;">
                                                                        ${emp.er}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td align="left"
                                                                        style="font-size: 13px;font-weight: 400;color: #000;padding:0 10px 10px;vertical-align: top;">
                                                                        ESIC2</td>
                                                                    <td align="right"
                                                                    style="font-size: 13px;font-weight: 500;color: #303030;padding: 0 10px 10px 0;">
                                                                    ${emp.esic2}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td align="left"
                                                                        style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;">
                                                                    </td>
                                                                    <td align="right"
                                                                        style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 0 10px 10px 0;">
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        </td>

                                                        <td style="vertical-align: top;border-left: 1px solid #b9b9b9;">
                                                            <table width="100%" style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr style="vertical-align: top;">
                                                                        <td style="padding-bottom: 10px;">
                                                                            <table width="100%" style="border-spacing:0px;" cellspacing="0"
                                                                                cellpadding="0" border="0">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th bgcolor="#8079A0" align="left"
                                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                                            Attendance Details
                                                                                        </th>
                                                                                        <th bgcolor="#8079A0"
                                                                                            style="font-size: 13px;font-weight: 500;color: #ffffff;padding: 10px 27px;border-bottom: 1px solid #b9b9b9;white-space: nowrap;">
                                                                                            Days
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td align="left"
                                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;">
                                                                                            Month Day</td>
                                                                                        <td align="center"
                                                                                            style="font-size: 13px;font-weight: 400;color: #303030; padding: 10px 0; vertical-align: top;">
                                                                                            ${emp.report?.totalDays}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td align="left"
                                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;">
                                                                                            Paid Leave</td>
                                                                                        <td align="center"
                                                                                            style="font-size: 13px;font-weight: 400;color: #303030; padding: 10px 0;vertical-align: top;">
                                                                                            ${emp.report?.paidLeaveDays}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td align="left"
                                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;">
                                                                                            Unpaid Leave</td>
                                                                                        <td align="center"
                                                                                            style="font-size: 13px;font-weight: 400;color: #303030;padding: 10px 0;vertical-align: top;">
                                                                                            ${emp.report?.unpaidLeaveDays}'</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td align="left"
                                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;">
                                                                                            LWP/Absent</td>
                                                                                        <td align="center"
                                                                                            style="font-size: 13px;font-weight: 400;color: #303030;padding: 10px 0;vertical-align: top;">
                                                                                            ${emp.report?.totalWorkingDays - (emp.report?.present_days + emp.report?.paidLeaveDays)}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td align="left"
                                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;">
                                                                                            Days Paid</td>
                                                                                        <td align="center"
                                                                                            style="font-size: 13px;font-weight: 400; padding: 10px 0; color: #303030;vertical-align: top;">
                                                                                            ${emp.report?.paidDays}</td>
                                                                                        <!-- <td align="center" style="font-size: 13px;font-weight: 400;color: #303030;vertical-align: top;">{{ this.paiddays_slip - ((this.salaryslipmlcount + this.salaryslipclcount + this.dayspresent) - (presentcount_slip + cl_slip + ml_slip))}}</td> -->
                                                                                        <!-- <td align="center" style="font-size: 13px;font-weight: 400;color: #303030;vertical-align: top;">{{ this.daysinmonth - (this.working_days_slip - (presentcount_slip+ + cl_slip + ml_slip))}}</td> -->
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
            
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td style="border-top: 1px solid #b9b9b9;padding:15px 15px 15px 0;">
                                                            <table style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding: 10px 10px 10px;vertical-align: top;">
                                                                            Total Rs.</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 10px 10px 10px 0;">
                                                                            ${emp.employee_salary?.gross_pay}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td
                                                            style="border-top: 1px solid #b9b9b9;padding: 15px;border-left: 1px solid #b9b9b9;">
                                                            <table style="border-spacing:0px;" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 500;color: #000;padding:10px;vertical-align: top;">
                                                                           ${emp.gross_pay}</td>
                                                                        <td align="right"
                                                                            style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 0 10px 10px 0;">
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="border-top: 1px solid #b9b9b9;padding: 15px;border-left: 1px solid #b9b9b9;">
                                                            <table  style="border-spacing:0px;width:100%" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left" style="font-size: 13px;font-weight: 400;color: #000;padding:12px 20px 10px 10px;vertical-align: top;">
                                                                            Amount
                                                                        </td>
                                                                        <td align="right" style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 12px 0 10px 0;">
                                                                            ${emp.totaldeduction}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="border-top: 1px solid #b9b9b9;padding: 15px;border-left: 1px solid #b9b9b9;">
                                                            <table  style="border-spacing:0px;width:100%" cellspacing="0" cellpadding="0"
                                                                border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left" style="font-size: 13px;font-weight: 400;color: #000;padding:12px 20px 10px 10px;vertical-align: top;">
                                                                            Amount
                                                                        </td>
                                                                        <td align="right" style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 12px 0 10px 0;">
                                                                            ${emp.companydeduction}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td style="border: 1px solid #b9b9b9;padding: 15px;">
                                                            <table style="border-spacing:0px;" cellspacing="0" cellpadding="0" border="0">
                                                                <tbody>
                                                                    <tr>
                                                                        <td align="left"
                                                                            style="font-size: 13px;font-weight: 400;color: #000;padding:10px;vertical-align: top;white-space: nowrap;">
                                                                            Net Salary Payable</td>
                                                                        <td align="right" style="font-size: 13px;font-weight: 500;color: #303030;vertical-align: top;padding: 10px 10px 10px 0;">
                                                                            ${emp.netpay}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="5"
                                                            style="border-top: 1px solid #b9b9b9;padding: 15px;font-size: 12px;font-weight: 400;color: #000;">
                                                            <span style="font-weight: 700;padding-right: 5px;">Salary In Words</span>
                                                            ${emp.salaryinwords}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
       </div>`;
            //console.log('htmldemo==================', htmldemo);
            htmldemo += ``;
            if (sendEmail) {
                const pdfOptions = {
                filename: emp.fname.concat("-", "payslip").concat("-", this.filterMonth.concat("-", emp.empid)),
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                html2canvas: { scale: 2 }
            };

            // Generate PDF blob
            const pdfBlob = await html2pdf()
                .set(pdfOptions)
                .from(htmldemo)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    return pdf.output('blob');
                });
                try {
                    // Convert blob to base64 for Laravel
                    const base64Pdf = await new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result.split(',')[1]);
                        reader.readAsDataURL(pdfBlob);
                    });
                    // const response =
                    await axios.post(`${BASE_URL}/send-payslip`, {
                        employee_id: emp.id, // MongoDB _id
                        email: emp.email,
                        fname: emp.fname,
                        pdf_base64: base64Pdf,
                        filename: pdfOptions.filename + '.pdf',
                        month_year: this.formatMonthYear(this.filterMonth),
                        orgname: company.orgname,
                    });
                    createToast('Payslip sent successfully!', { type: 'success' });
                    
                    //return response.data;
                } catch (error) {
                    console.error('Error sending email:', error);
                    //alert('Failed to send payslip. Please try again.');
                    //throw error;
                }
            } else {
                // Just download if not sending email
                html2pdf(htmldemo, {
                filename: emp.fname
                    .concat("-", "payslip")
                    .concat("-", this.filterMonth.concat("-", emp.empid)),
                });
            }

        },


        isOpen(employee) {
            const config = this.salaryConfig;
            this.selectedEmployee = employee;

            // Helper values
            const report = this.selectedEmployee?.report || {};
            const salary = this.selectedEmployee?.employee_salary || {};

            const totalDaysInMonth = report.totalDaysInMonth || 30;
            const paidDays = (report.present_days || 0) + (report.paidLeaveDays || 0);
            const payableDays = (report.totalDays || 30) - ((report.totalWorkingDays || 0) - paidDays);
            const paidRatio = payableDays / totalDaysInMonth;

            // Basic components
            const rawBasic = salary.basic * paidRatio;
            const rawHRA = salary.hra * paidRatio;
            const rawOther = salary.other_allowance * paidRatio;

            this.selectedEmployee.basic = Math.round(rawBasic);
            this.selectedEmployee.hra = Math.round(rawHRA);
            this.selectedEmployee.other_allowance = Math.round(rawOther);

            // Gross Pay
            const grossPay = rawBasic + rawHRA + rawOther;
            this.selectedEmployee.gross_pay = Math.round(grossPay);

            // PTax
            this.selectedEmployee.ptax = 0;
            for (let slab of config.ptax) {
                if (grossPay >= +slab.from && grossPay <= +slab.to) {
                    this.selectedEmployee.ptax = +slab.amount;
                    break;
                }
            }

            // PF Payable
            const basicPlusAllowance = this.selectedEmployee.basic + this.selectedEmployee.other_allowance;
            if (basicPlusAllowance <= 15000) {
                this.selectedEmployee.pfpayable = Math.round(basicPlusAllowance * 0.12);
            } else if (salary.epf_amount === 0) {
                this.selectedEmployee.pfpayable = 0;
            } else {
                this.selectedEmployee.pfpayable = 1800;
            }

            // EPS and ER
            this.selectedEmployee.eps = Math.round((this.selectedEmployee.pfpayable * 8.33) / 12);
            this.selectedEmployee.er = this.selectedEmployee.pfpayable - this.selectedEmployee.eps;

            // ESI
            // if (grossPay <= 21000 && config.esi.enabled === 'true' ) {
            //     this.selectedEmployee.esi = Math.round((grossPay * 0.75) / 100);
            // } else {
            //     this.selectedEmployee.esi = 0;
            // }

            // // ESIC2
            // this.selectedEmployee.esic2 = Math.round((this.selectedEmployee.esi * 3.25) / 0.75);
            //this.selectedEmployee.esic2 = Math.round((grossPay * 3.25) / 100);

            // ESI Calculation
            this.selectedEmployee.esi = config.esi.enabled === 'true' && salary.gross_pay <= 21000
                ? Math.round((grossPay * 0.0075))
                : 0;

            // Employer ESI (ESIC2)
            this.selectedEmployee.esic2 = config.esi.enabled === 'true' && salary.gross_pay <= 21000
                ? Math.round((grossPay * 0.0325))
                : 0;

            // Total Deduction
            this.selectedEmployee.totaldeduction =
                this.selectedEmployee.pfpayable +
                this.selectedEmployee.esi +
                this.selectedEmployee.ptax;

            // Net Pay
            this.selectedEmployee.netpay =
                this.selectedEmployee.gross_pay -
                this.selectedEmployee.totaldeduction;
            var num = this.selectedEmployee.netpay;
            this.selectedEmployee.salaryinwords = this.number2text(num);
            // Company Deduction
            this.selectedEmployee.companydeduction =
                this.selectedEmployee.eps +
                this.selectedEmployee.er +
                this.selectedEmployee.esic2;

            // PF for CTC calculation
            let pf_ctc = 0;
            if (salary.epf_amount !== 0) {
                if (basicPlusAllowance > 15000) {
                    pf_ctc = 1800;
                } else {
                    pf_ctc = basicPlusAllowance * 0.12;
                }
            }

            console.log(pf_ctc, "------pf_ctc", paidRatio, grossPay, this.selectedEmployee.esic2)

            // CTC Calculation
            const ctcValue = (grossPay / paidRatio) + pf_ctc + this.selectedEmployee.esic2;
            this.selectedEmployee.ctc = Math.round(ctcValue);

            console.log("CTC:", this.selectedEmployee.ctc);

            this.isPopupOpen = true;
        },

        async fetchSalaryRequests() {
            try {
                // Only reset page if location changed (not just when it has a value)
                if (this.slectedLocation !== this.previousLocation) {
                    this.currentPage = 1;
                    this.previousLocation = this.slectedLocation;
                }
                this.loading = true; // Start loader
                this.data = []; // ✅ Clear old data immediately
                const response = await axios.post(`${BASE_URL}/get-employee-salary-month-wise`, {
                    month: this.filterMonth,
                    // <-- add month here
                    limit: this.itemsPerPage,
                    page: this.currentPage,
                    name: this.searchQuery,
                    location: this.slectedLocation,
                });

                this.data = response.data.data;
                this.total = response.data.total;

            } catch (error) {
                console.error("Error fetching employees:", error);
            } finally {
                this.loading = false; // Stop loader
            }
        },






        async fetchSalaryConfig() {
            try {
                const formData = {
                    "company_id": localStorage.getItem('company_id')
                };
                const response = await axios.post(BASE_URL + '/get-payroll-data', formData);
                console.log('payroll data', response.data);//here is the response i have provided to you
                if (response.data && response.data.payrollData.length > 0) {
                    const payrollRecord = response.data.payrollData[0];

                    // Assign values, parsing JSON where needed
                    this.salaryConfig = {
                        id: payrollRecord.id,
                        company_id: payrollRecord.company_id,
                        basic: payrollRecord.basic,
                        hra: payrollRecord.hra,
                        allowances: JSON.parse(payrollRecord.allowances || '[]'),
                        esi: JSON.parse(payrollRecord.esi || '{"enabled": "false" }'),
                        pf: JSON.parse(payrollRecord.pf || '{"enabled": "false" }'),
                        ptax: JSON.parse(payrollRecord.ptax || '[]')
                    };
                } else {
                    //this.isEditing = false;
                }
            } catch (error) {
                console.error('Error fetching payroll data:', error);
                alert('Error fetching payroll data!');
            }
        },

        onSearch() {
            this.currentPage = 1;
            this.fetchSalaryRequests();
        },

        logEffectiveFrom(value) {
            console.log("Effective From Changed:", value);
            this.filterMonth = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
                    // Clear data and set loading immediately
        this.loading = true;
        this.data = [];
            this.fetchSalaryRequests();
        },

        number2text(value) {
            const fraction = Math.round(this.frac(value) * 100);
            let f_text = "";

            if (fraction > 0) {
                f_text = "AND " + this.convert_number(fraction) + " PAISE";
            }

            return this.convert_number(Math.floor(value)) + " RUPEE " + f_text + " ONLY";
        },

        convert_number(number) {
            if (number < 0 || number > 999999999) {
                return "NUMBER OUT OF RANGE!";
            }

            const Gn = Math.floor(number / 10000000); // Crore
            number -= Gn * 10000000;
            const kn = Math.floor(number / 100000); // Lakh
            number -= kn * 100000;
            const Hn = Math.floor(number / 1000); // Thousand
            number -= Hn * 1000;
            const Dn = Math.floor(number / 100); // Hundreds
            number = number % 100; // Tens & Ones
            const tn = Math.floor(number / 10);
            const one = number % 10;

            let res = "";

            if (Gn > 0) res += this.convert_number(Gn) + " CRORE";
            if (kn > 0) res += (res ? " " : "") + this.convert_number(kn) + " LAKH";
            if (Hn > 0) res += (res ? " " : "") + this.convert_number(Hn) + " THOUSAND";
            if (Dn > 0) res += (res ? " " : "") + this.convert_number(Dn) + " HUNDRED";

            const ones = [
                "", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX",
                "SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE",
                "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN",
                "SEVENTEEN", "EIGHTEEN", "NINETEEN"
            ];
            const tens = [
                "", "", "TWENTY", "THIRTY", "FORTY", "FIFTY",
                "SIXTY", "SEVENTY", "EIGHTY", "NINETY"
            ];

            if (tn > 0 || one > 0) {
                res += (res ? " AND " : "");
                if (tn < 2) {
                    res += ones[tn * 10 + one];
                } else {
                    res += tens[tn];
                    if (one > 0) {
                        res += "-" + ones[one];
                    }
                }
            }

            if (!res) res = "ZERO";
            return res;
        },

        frac(value) {
            return value - Math.floor(value);
        }

    },
    created() {
        const page = parseInt(this.$route.query.page) || 1;
        this.currentPage = page;
        if (this.storage.userType === 'Super Admin') {               
                this.slectedLocation = ''; // Set to an empty string or a default value
                this.userType = 'admin';
            } else {
                this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
                this.userType = 'not-admin';
                console.log('branch', this.slectedLocation);
            }
           this.getBranchList();
           

        this.onSearch = debounce(this.onSearch, 400);
    },
    async mounted() {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        this.filterMonth = `${year}-${month}`;
        await this.fetchSalaryConfig();
        this.fetchSalaryRequests();
        this.fetchData()
    }
};
</script>
<style>
.fit-input-month .month-picker-input {
    width: 100% !important;
}
</style>
<style scoped>
.grid-cols-13 {
    grid-template-columns: repeat(13, minmax(0, 1fr));
}
</style>